import React from "react";
import ContentLoader from "react-content-loader";

export default props =>{
    return <ContentLoader
        speed={2}
        viewBox="0 0 400 1000"
        backgroundColor={'#eee'}
        foregroundColor={'#ccc'}
    >
        {/* 图标 */}
        <rect x="10" y="0" width="380" height="60" />

        {/* 选择卡片 */}
        <rect x="10" y="61" width="380" height="116" />

        {/* 地址 */}
        <rect x="10" y="187" width="380" height="130" />

        {/* 支付方式 */}
        <rect x="10" y="327" width="380" height="144" />
        <rect x="10" y="472" width="380" height="45" />

        {/* pay now */}
        <rect x="10" y="492" width="380" height="44" />

    </ContentLoader>
}